import { Modal, Button } from "antd";
import React from "react";

interface IProps {
  visualizar: boolean;
  setVisualizar: any;
  onAceptar: any;
}

export const ModalExitoso: React.FC<IProps> = (props: IProps) => {
  return (
    <Modal
      visible={props.visualizar}
      closeIcon={false}
      width={800}
      onCancel={props.onAceptar}
      style={{ top: 50 }}
      footer={[
        <Button key="B_AceptarModalExitoso" className="button-azul-radius" onClick={props.onAceptar}>
          ACEPTAR
        </Button>,
      ]}
      maskStyle={{
        backgroundColor: "rgba(24,154,93)",
      }}
    >
      <div className="row">
        <div className="col-12 font-size-24px font-color-00904C font-family-Montserrat-Bold justify-content-center">
          Proceso éxitoso
        </div>
        <div className="col-12 font-family-Montserrat-Regular font-size-16px justify-content-center">
          Se a cambiado la contraseña exitosamente
        </div>
        <div className="col-12 font-family-Montserrat-SemiBold font-size-16px justify-content-center">
          A continuación inicie sesión
        </div>
      </div>
    </Modal>
  );
};
